import React from 'react';

import { VerifyEmailForm } from './children/VerifyEmailFrom';

export const VerifyEmail = () => {
    return <VerifyEmailForm />;
};
